export default __webpack_public_path__ + "static/media/more.35ec626e.svg";